'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _astralLetterAndMarks = require('./astralLetterAndMarks');

var _astralLetterAndMarks2 = _interopRequireDefault(_astralLetterAndMarks);

var _astralNumerals = require('./astralNumerals');

var _astralNumerals2 = _interopRequireDefault(_astralNumerals);

var _bmpLetterAndMarks = require('./bmpLetterAndMarks');

var _bmpLetterAndMarks2 = _interopRequireDefault(_bmpLetterAndMarks);

var _bmpNumerals = require('./bmpNumerals');

var _bmpNumerals2 = _interopRequireDefault(_bmpNumerals);

var _hashtagSpecialChars = require('./hashtagSpecialChars');

var _hashtagSpecialChars2 = _interopRequireDefault(_hashtagSpecialChars);

var _nonBmpCodePairs = require('./nonBmpCodePairs');

var _nonBmpCodePairs2 = _interopRequireDefault(_nonBmpCodePairs);

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hashtagAlphaNumeric = (0, _regexSupplant2.default)(/(?:[#{bmpLetterAndMarks}#{bmpNumerals}#{hashtagSpecialChars}]|(?=#{nonBmpCodePairs})(?:#{astralLetterAndMarks}|#{astralNumerals}))/, {
  bmpLetterAndMarks: _bmpLetterAndMarks2.default,
  bmpNumerals: _bmpNumerals2.default,
  hashtagSpecialChars: _hashtagSpecialChars2.default,
  nonBmpCodePairs: _nonBmpCodePairs2.default,
  astralLetterAndMarks: _astralLetterAndMarks2.default,
  astralNumerals: _astralNumerals2.default
}); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = hashtagAlphaNumeric;
module.exports = exports['default'];